export default "__VITE_ASSET__Bl_6eIp4__"